import { render, staticRenderFns } from "./SettingGlobalList.vue?vue&type=template&id=2e5afe10&"
import script from "./SettingGlobalList.vue?vue&type=script&lang=ts&"
export * from "./SettingGlobalList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports